"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cancelActiveCell = cancelActiveCell;
exports.editActiveCell = editActiveCell;
exports.submitActiveCell = submitActiveCell;
exports.insertColumns = insertColumns;
exports.removeColumns = removeColumns;
exports.loadDatasheet = loadDatasheet;
exports.insertRows = insertRows;
exports.removeRows = removeRows;
exports.clearSelection = clearSelection;
exports.jumpSelection = jumpSelection;
exports.moveSelection = moveSelection;
exports.resizeSelection = resizeSelection;
exports.insertSnippet = insertSnippet;
exports.SNIPPET_INSERT = exports.SELECTION_RESIZE = exports.SELECTION_MOVE = exports.SELECTION_JUMP = exports.SELECTION_CLEAR = exports.ROWS_REMOVE = exports.ROWS_INSERT = exports.DATASHEET_LOAD = exports.COLUMNS_REMOVE = exports.COLUMNS_INSERT = exports.ACTIVE_CELL_SUBMIT = exports.ACTIVE_CELL_EDIT = exports.ACTIVE_CELL_CANCEL = void 0;
var ACTIVE_CELL_CANCEL = 'activeCell.cancel';
exports.ACTIVE_CELL_CANCEL = ACTIVE_CELL_CANCEL;
var ACTIVE_CELL_EDIT = 'activeCell.edit';
exports.ACTIVE_CELL_EDIT = ACTIVE_CELL_EDIT;
var ACTIVE_CELL_SUBMIT = 'activeCell.submit';
exports.ACTIVE_CELL_SUBMIT = ACTIVE_CELL_SUBMIT;
var COLUMNS_INSERT = 'columns.insert';
exports.COLUMNS_INSERT = COLUMNS_INSERT;
var COLUMNS_REMOVE = 'columns.remove';
exports.COLUMNS_REMOVE = COLUMNS_REMOVE;
var DATASHEET_LOAD = 'datasheet.load';
exports.DATASHEET_LOAD = DATASHEET_LOAD;
var ROWS_INSERT = 'rows.insert';
exports.ROWS_INSERT = ROWS_INSERT;
var ROWS_REMOVE = 'rows.remove';
exports.ROWS_REMOVE = ROWS_REMOVE;
var SELECTION_CLEAR = 'selection.clear';
exports.SELECTION_CLEAR = SELECTION_CLEAR;
var SELECTION_JUMP = 'selection.jump';
exports.SELECTION_JUMP = SELECTION_JUMP;
var SELECTION_MOVE = 'selection.move';
exports.SELECTION_MOVE = SELECTION_MOVE;
var SELECTION_RESIZE = 'selection.resize';
exports.SELECTION_RESIZE = SELECTION_RESIZE;
var SNIPPET_INSERT = 'snippet.insert';
exports.SNIPPET_INSERT = SNIPPET_INSERT;

function cancelActiveCell() {
  return {
    type: ACTIVE_CELL_CANCEL,
    payload: {}
  };
}

function editActiveCell(value) {
  return {
    type: ACTIVE_CELL_EDIT,
    payload: {
      value: value
    }
  };
}

function submitActiveCell() {
  return {
    type: ACTIVE_CELL_SUBMIT,
    payload: {}
  };
}

function insertColumns(startIndex, columns) {
  return {
    type: COLUMNS_INSERT,
    payload: {
      startIndex: startIndex,
      columns: columns
    }
  };
}

function removeColumns(startIndex, endIndex) {
  return {
    type: COLUMNS_REMOVE,
    payload: {
      startIndex: startIndex,
      endIndex: endIndex
    }
  };
}

function loadDatasheet(columns, rows, file) {
  return {
    type: DATASHEET_LOAD,
    payload: {
      columns: columns,
      file: file,
      rows: rows
    }
  };
}

function insertRows(startIndex, rows) {
  return {
    type: ROWS_INSERT,
    payload: {
      startIndex: startIndex,
      rows: rows
    }
  };
}

function removeRows(startIndex, endIndex) {
  return {
    type: ROWS_REMOVE,
    payload: {
      startIndex: startIndex,
      endIndex: endIndex
    }
  };
}

function clearSelection(selection) {
  return {
    type: SELECTION_CLEAR,
    payload: {
      selection: selection
    }
  };
}

function jumpSelection(selection) {
  return {
    type: SELECTION_JUMP,
    payload: {
      selection: selection
    }
  };
}

function moveSelection(x, y) {
  var activeOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    type: SELECTION_MOVE,
    payload: {
      x: x,
      y: y,
      activeOnly: activeOnly
    }
  };
}

function resizeSelection(x, y) {
  return {
    type: SELECTION_RESIZE,
    payload: {
      x: x,
      y: y
    }
  };
}

function insertSnippet(snippet) {
  return {
    type: SNIPPET_INSERT,
    payload: {
      snippet: snippet
    }
  };
}